import { Icons } from '@assets';
import { IAcl, INavMenuItem } from '@types';
import { isAllow } from '@utils/functions';
import React from 'react';

const { HeaderIcons } = Icons;

export const settings = (rules: IAcl | undefined): INavMenuItem[] => [
    {
        name: 'Аккаунт',
        to: '/settings',
        icon: <img src={HeaderIcons.IconHeaderSetting} alt="icon setting" />,
        text: 'settings',
        navKey: 'settings.account',
        isAllow: isAllow(rules, 'settings'),
    },
    {
        name: 'Точки продаж ',
        desc: 'Точки продаж ',
        icon: <img src={HeaderIcons.IconHeaderSetting} alt="icon setting" />,
        to: '/settings/salepoints',
        text: 'settings_salepoints',
        navKey: 'settings.salepoints',
        isAllow: isAllow(rules, 'salepoints'),
    },
];

export default settings;
